import { combineReducers } from 'redux';

import { getType } from 'typesafe-actions';
import { actions } from '..';
import { FacebookPost, FacebookPage } from '../../model';
import { Actions, StoreState } from '../types';
import { createSelector } from 'reselect';
import { isDefined } from '../../type-utils';

interface FacebookPostById {
  [id: string]: { key: string, userId: string, userName: string, posts: FacebookPost[], page: FacebookPage }
}

function facebookPostsById(state: FacebookPostById = {}, action: Actions): FacebookPostById {
  switch (action.type) {
    case getType(actions.removeMediaItem): {
      const emails = state[action.payload]
      if (!emails) { return state }

      const { [action.payload]: _, ...rest } = state
      return rest
    }

    case getType(actions.fetchFacebookPostsResponse): {
      //userName can be '' as the database hasn't been updated yet
      const { key, userId, userName, posts, page } = action.payload
      return {
        ...state,
        [key]: { key, userId, userName, posts, page },
      }
    }
    case getType(actions.updateFacebookPost): {
      const { key, post } = action.payload
      //comment is either an update or added


      const facebook = state[key]
      if (!facebook) { return state }

      const posts = facebook.posts;
      const index = facebook.posts.findIndex(x => x.postId === post.postId)

      if (index === -1) {
        return {
          ...state,
          [key]: { ...facebook, posts: [post, ...posts] },
        }
      } else {
        return {
          ...state,
          [key]: { ...facebook, posts: [...posts.slice(0, index), post, ...posts.slice(index + 1)] },
        }
      }

    }

    case getType(actions.updateFacebookComment): {
      //decided to put logic into push updates for now and see what Vic wants to do

      return state;
    }
    default:
      return state
  }

}

export default combineReducers({
  facebookPostsById,
})

function getRoot(state: StoreState) { return state.facebook }
function getFacebookPostsById(state: StoreState) { return getRoot(state).facebookPostsById }

export function getFacebookPostById(state: StoreState, id: string) {
  return getFacebookPostsById(state)[id]
}

export function selectFacebookByPostId(state: StoreState, postId: string): { key: string, userId: string, userName: string, posts: FacebookPost[], page: FacebookPage } | undefined {
  return selectFacbook(state).filter(fb => fb.posts.find(p => p.postId === postId))[0]
}

export function selectFacebookByUserId(state: StoreState, userId: string, pageId: string): { key: string, userId: string, userName: string, posts: FacebookPost[], page: FacebookPage } | undefined {
  return selectFacbook(state).filter(fb => fb.userId === userId && fb.page.pageId === pageId)[0]
}

export const selectFacbook = createSelector(
  getFacebookPostsById,
  facebooks => {
    return Object.values(facebooks).filter(isDefined)
  },
)
